<style lang='less' scoped>
    @import '../base.less';
</style>
<template>
    <div>
        <!-- SEARCH -->
        <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline> 
                    <FormItem style="margin-bottom: 0">
              <DatePicker type="datetimerange"  :options="timeOptions" :value='searchConf.searchTime' @on-change='timeChange' format="yyyy-MM-dd"
                          :placeholder="$t('选择时间')" style="width: 200px">
              </DatePicker>
            </FormItem><FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
        <Row>
            <Col span='24'>
            <Card>
                <!-- ADDBUTTON -->
                                <!-- DATA -->
                <div>
                    <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
                </div>
                <!-- PAGE -->
                <div class='margin-top-15' style='text-align: center'>
                    <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                          @on-change='changePage' @on-page-size-change='changeSize'
                          :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
                </div>
            </Card>
            </Col>
        </Row>
        <!-- windowAddEdit -->
        
        <!--    -->
    </div>
</template>
<script>
    import {
        getList
    } from '@/api/dataManage/payChannelReport'
    import {
        formattingMonth,
        lastMonthDate
    } from '@/libs/time'

    export default {
        name: 'interface_list',
        data () {
            return {
                timeOptions: {
                    shortcuts: [{
                        text: '今天',
                        value () {
                            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
                            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                            return [a, b]
                        }
                    },
                        {
                            text: '昨天',
                            value () {
                                let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
                                let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                                    60 * 1000 - 1)
                                return [a, b]
                            }
                        },
                        {
                            text: '一周',
                            value () {
                                let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
                                let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                                return [a, b]
                            }
                        },
                        {
                            text: '本月',
                            value () {
                                return formattingMonth()
                            }
                        },
                        {
                            text: '上月',
                            value () {
                                return lastMonthDate()
                            }
                        },
                    ]
                },
                columnsList: [ {
        title: this.$t('通道名称'),
        key: 'title',
          
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('方式'),
        key: 'pay_name',
          
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('成功金额'),
        key: 'success_money',
          
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('充值赠送金额'),
        key: 'send_money',
          
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('订单笔数'),
        key: 'order_count',
          
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('订单总金额'),
        key: 'total_money',
          
        minWidth: 120,
        align: 'center'
      },],
                tableData: [],//用于放LIST数据绑定
                tableShow: { //用于分页
                    currentPage: 1,
                    pageSize: 10,
                    listCount: 0
                },
                searchConf: { searchTime: [], }, // 搜索字段

                buttonShow: { //按钮状态显示
                    edit: true,
                    del: true,
                    changeStatus: true
                },
                listLoading: false, //显示加载中状态
                //弹窗--------------
                            //----------------
            }
        },
        created () {
            let vm = this
            vm.getList()
            vm.hasRule('dataManage/payChannelReport/edit').then(res => {
                vm.buttonShow.edit = res
            })
            vm.hasRule('dataManage/payChannelReport/del').then(res => {
                vm.buttonShow.del = res
            })
            vm.hasRule('dataManage/payChannelReport/changeStatus').then(res => {
                vm.buttonShow.changeStatus = res
            })
        },
        methods: {
                changePage (page) {
                this.tableShow.currentPage = page
                this.getList()
            },
            changeSize (size) {
                this.tableShow.pageSize = size
                this.getList()
            },
            search () {
                this.tableShow.currentPage = 1
                this.getList()
            },
            getList () {
                let vm = this
                vm.listLoading = true
                getList({
                    page: vm.tableShow.currentPage,
                    size: vm.tableShow.pageSize,
                    search: vm.searchConf
                }).then(response => {
                    vm.tableData = response.data.data.list
                    vm.tableShow.listCount = response.data.data.count
                    vm.listLoading = false
                })
            },

        timeChange (datetimerange) { //时间修改，自动计算尾部时间
        if (datetimerange[0] !== '' && datetimerange[1] !== '') {
            let patt = /00:00:00/
            this.searchConf.searchTime =[datetimerange[0], datetimerange[1]]
            if (patt.test(datetimerange[1])) {
                datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
                this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
            }
        } else {
            this.searchConf.searchTime = []
        }
    },
        sortChange: function ({ column, key, order }) {
            //order值可能为asc,desc,normal
            this.searchConf.order = [key, order]
            if (order == 'normal') {
                this.searchConf.order = []
            }
            this.getList()
        },
                }
    }
</script>
